import { sendToApi } from 'api/client'
import { defaultLongCacheTime } from 'queryClient'
import { useQuery, UseQueryOptions } from 'react-query'
import { Response } from 'request-dot-js'
import { FilesCounts } from '../../../api/clients/FilesViewsClient'

interface Options {
  workspaceId: number
  location: string
  query: object
  disableSchema?: boolean
}

const supportedSchemasForCounts = ['your_files', 'recent', 'shared_with_you', 'imported']

const fetchFilesCounts = ({ workspaceId, location, query }: Options) => {
  return () => {
    if (!supportedSchemasForCounts.includes(location)) return

    return sendToApi<FilesCounts>(`/w/${workspaceId}/files_views/counts?schema=${location}`, {
      method: 'GET',
      params: {
        ...query,
      },
    })
  }
}

export const useFilesCounts = (options: Options, queryOptions: UseQueryOptions<any> = {}) => {
  return useQuery<Response<FilesCounts> | undefined>(
    ['workspace', options.workspaceId, 'files', options.location, options.query],
    fetchFilesCounts(options),
    {
      cacheTime: defaultLongCacheTime,
      ...queryOptions,
    },
  )
}
